import styled from 'styled-components'

export const MenuWrapper = styled.div`
  padding: 8px 0 16px;
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

// ----- invoice form -----
export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`

export const SettingWrapper = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;

  .ant-input-outlined.ant-input-disabled, .ant-input-outlined[disabled],
  .ant-picker-outlined.ant-picker-disabled, .ant-picker-outlined[disabled],
  .ant-picker .ant-picker-input >input[disabled],
  .ant-picker-outlined.ant-picker-disabled:hover:not([disabled]), .ant-picker-outlined[disabled]:hover:not([disabled]),
  .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector,
  .ant-checkbox-disabled+span {
    color: rgba(0,0,0,0.88);
    background-color: rgb(255, 255, 255);
  }
`

export const BasicSettingWrapper = styled.div`
  width: 320px;
  padding: 24px;
  border-right: 1px solid rgba(0,0,0,.1);
`

export const CustomSettingWrapper = styled.div`
  width: calc(100% - 320px);
  padding: 24px;

  .ant-empty-description {
    color: rgba(0,0,0,.3);
  }
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`

export const LogicTitle = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 500;
  padding-bottom: 8px;
`

export const HorizontalFormWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  > div {
    flex-basis: 0;
    flex-grow: 1;
  }
  
  .ant-form-item {
    margin-bottom: 0px;
  }
`

// ----- invoice dashboard -----
const StatisticBorder = '1px solid rgba(0,0,0,.2)'
export const StatisticWrapper = styled.div`
  display: flex;
  margin: 16px 0;

  .ant-statistic {
    width: 25%;
    padding: 16px 0;
    background: rgba(0,0,0,.05);
  }
  .ant-statistic-title, .ant-statistic-content {
    text-align: center;
  }
  .ant-statistic:first-child {
    border-left: ${StatisticBorder};
    border-top: ${StatisticBorder};
    border-bottom: ${StatisticBorder};
    background: transparent;
  }
  .ant-statistic:nth-child(3) {
    border-right: ${StatisticBorder};
    border-top: ${StatisticBorder};
    border-bottom: ${StatisticBorder};
    background: transparent;
  }
`

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin: 24px 12px 24px;
`

export const VerticalLineWrapper = styled.div`
  display: flex;
  align-items: center;
  background: rgba(0,0,0,.05);
  &:nth-child(2) {
    background: transparent;
  }
`
export const VerticalLine = styled.div`
  width: 1px;
  height: 60px;
  background: rgba(0,0,0,.2);
`

export const RowWrapper = styled.div`
  width: 100%;
  gap: 24px;
  display: flex;
  margin-bottom: 32px;
  > div {
    width: 100%;
  }
`

export const ChartWrapper = styled.div`
  .ant-divider {
    margin: 8px 0;
    font-weight: 600;
    font-size: 16px;
  }

  ${({ fullheight }) => fullheight
  ? `
    display: flex;
    flex-direction: column;
  `
  : ''}
  ${({ fullwidth }) => fullwidth
  ? `
    height: 180;
    margin-bottom: 24px;
  `
  : ''}
`

export const ChartWrapperInner = styled.div`
  border: ${({ borderless }) => borderless ? '' : StatisticBorder};
  height: 100%;
  padding: ${({ borderless }) => borderless ? '0 16px 32px' : '24px 24px 16px'};
  display: flex;
  align-items: center;
  justify-content: center;
`
